import React from 'react';
const AboutUs = () => {
  return <div className="min-h-screen bg-white" data-id="element-243">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-244">
        <div className="container mx-auto px-4" data-id="element-245">
          <h1 className="text-3xl font-bold text-center mb-4" data-id="element-246">
            About Maplewood-Care
          </h1>
          <p className="text-lg text-center max-w-3xl mx-auto" data-id="element-247">
            Your trusted partner for appliance repair and maintenance services
            across the United Kingdom
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-248">
        <div className="flex flex-col md:flex-row items-center mb-12" data-id="element-249">
          <div className="md:w-1/3 mb-8 md:mb-0 flex justify-center" data-id="element-250">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rh7WhzbDRZRPrDVQaRHwDN/Maplewood_staff_fixing_AC.jpg" alt="Maplewood Care Engineer Fixing AC" className="max-w-full md:max-w-xs object-cover rounded-md shadow-md" data-id="element-251" />
          </div>
          <div className="md:w-2/3 md:pl-12" data-id="element-252">
            <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-253">
              Our Story
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-254">
              Maplewood-Care was founded with a simple mission: to provide
              reliable, professional appliance repair services that people can
              trust. With years of experience in the industry, we've built a
              reputation for excellence, integrity, and customer satisfaction.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-255">
              Our team of highly skilled engineers are fully qualified and
              trained to work with all major brands and types of household
              appliances. We understand the inconvenience of appliance
              breakdowns, which is why we're committed to providing prompt,
              efficient service to get your home back to normal as quickly as
              possible.
            </p>
            <p className="text-gray-700" data-id="element-256">
              At Maplewood-Care, we believe in transparency, reliability, and
              customer satisfaction. Our prepaid service packages are designed
              to give you peace of mind, knowing that your appliances are
              maintained by professionals who care.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-257">
          <div className="bg-mwc-lightpink p-6 rounded-lg" data-id="element-258">
            <h3 className="text-xl font-bold text-mwc-burgundy mb-3" data-id="element-259">
              Our Values
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-260">
              <li className="flex items-center" data-id="element-261">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-262"></span>
                <span data-id="element-263">Integrity in all our dealings</span>
              </li>
              <li className="flex items-center" data-id="element-264">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-265"></span>
                <span data-id="element-266">Excellence in service delivery</span>
              </li>
              <li className="flex items-center" data-id="element-267">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-268"></span>
                <span data-id="element-269">Customer satisfaction as our priority</span>
              </li>
              <li className="flex items-center" data-id="element-270">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-271"></span>
                <span data-id="element-272">Transparency in pricing and service</span>
              </li>
              <li className="flex items-center" data-id="element-273">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-274"></span>
                <span data-id="element-275">Continuous improvement and learning</span>
              </li>
            </ul>
          </div>
          <div className="bg-mwc-lightpink p-6 rounded-lg" data-id="element-276">
            <h3 className="text-xl font-bold text-mwc-burgundy mb-3" data-id="element-277">
              Our Team
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-278">
              Our engineers are the backbone of Maplewood-Care. Each member of
              our team is:
            </p>
            <ul className="space-y-2 text-gray-700" data-id="element-279">
              <li className="flex items-center" data-id="element-280">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-281"></span>
                <span data-id="element-282">Fully qualified and certified</span>
              </li>
              <li className="flex items-center" data-id="element-283">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-284"></span>
                <span data-id="element-285">Regularly trained on new technologies</span>
              </li>
              <li className="flex items-center" data-id="element-286">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-287"></span>
                <span data-id="element-288">Background checked for your security</span>
              </li>
              <li className="flex items-center" data-id="element-289">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-290"></span>
                <span data-id="element-291">Committed to customer satisfaction</span>
              </li>
            </ul>
          </div>
          <div className="bg-mwc-lightpink p-6 rounded-lg" data-id="element-292">
            <h3 className="text-xl font-bold text-mwc-burgundy mb-3" data-id="element-293">
              Our Commitment
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-294">
              When you choose Maplewood-Care, you're choosing:
            </p>
            <ul className="space-y-2 text-gray-700" data-id="element-295">
              <li className="flex items-center" data-id="element-296">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-297"></span>
                <span data-id="element-298">Prompt response to your service needs</span>
              </li>
              <li className="flex items-center" data-id="element-299">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-300"></span>
                <span data-id="element-301">Quality repairs that last</span>
              </li>
              <li className="flex items-center" data-id="element-302">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-303"></span>
                <span data-id="element-304">Clear communication throughout the process</span>
              </li>
              <li className="flex items-center" data-id="element-305">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-306"></span>
                <span data-id="element-307">Fair and transparent pricing</span>
              </li>
              <li className="flex items-center" data-id="element-308">
                <span className="w-2 h-2 bg-mwc-burgundy rounded-full mr-2" data-id="element-309"></span>
                <span data-id="element-310">A genuine desire to solve your problems</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center" data-id="element-311">
          <h2 className="text-2xl font-bold text-mwc-burgundy mb-6" data-id="element-312">
            Ready to Experience the Maplewood-Care Difference?
          </h2>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-313">
            <a href="/contact-us" className="bg-mwc-burgundy hover:bg-mwc-darkburgundy text-white font-semibold px-6 py-3 rounded-md transition-colors duration-300 inline-block" data-id="element-314">
              Contact Us Today
            </a>
            <a href="/service-coverage" className="bg-mwc-green hover:bg-mwc-green/80 text-white font-semibold px-6 py-3 rounded-md transition-colors duration-300 inline-block" data-id="element-315">
              Explore Service Details
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default AboutUs;